<script setup lang="ts">
  import { useNeoDotStore } from '@/stores/neo-dot';
  import { useThemeStore } from '@/stores/theme';

  /**
   * 캘린더에서 날짜 선택시 Neo-dot 일일 경우 표시,
   * 날짜 클릭해 페이지 이동하더라도 표시하기 위해 글로벌 상태로 관리
   */
  const neoDotStore = useNeoDotStore();

  const themeStore = useThemeStore();
</script>

<template>
  <div
    class="bg-base-100"
    :data-theme="themeStore.theme">
    <ErrorBoundary>
      <RouterView />

      <AppModal
        id="about_neodot"
        :is-visible="neoDotStore.isVisible"
        has-close-x
        @close="() => neoDotStore.togglePopup()">
        <h3 class="text-lg font-bold">“Neo-dot”으로 휴식을 채워보세요.</h3>
        <div class="py-4">
          <p class="text-sm">
            한 달에 반드시 채워야 하는 '의무근로시간'을 모두 채웠다면, 마지막
            날은 잠시 쉬어가며 몸과 마음을 충전할 수 있습니다.
          </p>
          <p class="py-1 text-sm">
            Neo-dot은 일과 일상을 모두 채울 수 있는 제도로 사용하기 위해 별도의
            등록절차는 없습니다.
          </p>
          <p class="py-1 text-sm">
            만약 의무근로시간을 모두 채우지 못했다면 마지막 날에 근무를 진행해야
            합니다. 반대로 의무근로시간을 초과했지만 근무가 필요한 경우 근무
            등록과 승인이 필요합니다.
          </p>
        </div>

        <template #action>
          <div class="text-center">
            <button
              class="text-lg btn btn-block"
              @click="() => neoDotStore.togglePopup()">
              😉 알겠습니다
            </button>
          </div>
        </template>
      </AppModal>
    </ErrorBoundary>
  </div>
</template>
